module.exports = __webpack_public_path__ + "static/media/giftcard-holiday.6849c582.jpg";